import { createRouter, createWebHashHistory } from "@ionic/vue-router";
import { getUserInfo } from "@/service/account";
import store from "@/store/business";

const routeModules = import.meta.glob("./*.js", { eager: true });
const siteRoutes = Object.entries(routeModules)
    .filter(([path]) => path !== "./index.js")
    .flatMap(([, mod]) => mod.default || []);

const routes = [
    {
        path: "/",
        name: "index",
        component: () => import("@/views/Index.vue"),
    },
    {
        path: "/_dev/shell",
        name: "Home",
        component: () => import("@/views/home/index.vue"),
    },
    ...siteRoutes,
    {
        path: "/forbidden",
        name: "NotAuthenticated",
        component: () => import("@/views/_/NotAuthenticated.vue"),
    },
    { path: "/:pathMatch(.*)*", name: "NotFound", component: () => import("@/views/_/NotFound.vue") },
];

const router = createRouter({
    history: createWebHashHistory(import.meta.env.BASE_URL),
    routes,
});

let userInfoLoadedToken = "";

function getTokenFromSearch() {
    try {
        return new URLSearchParams(window.location.search || "").get("token") || "";
    } catch (error) {
        return "";
    }
}

router.beforeEach(async (to) => {
    const cachedToken = localStorage.getItem("token") || "";
    const queryToken = to?.query?.token || "";
    const searchToken = getTokenFromSearch();
    const token = queryToken || cachedToken || searchToken;

    if (token && token !== cachedToken) {
        localStorage.setItem("token", token);
        store.commit("setToken", token);
    }

    if (!token || to.name === "profile") {
        return true;
    }

    let user = store.state.user || {};
    const hasUser = Object.keys(user).length > 0;
    const shouldFetchUser = !hasUser || userInfoLoadedToken !== token;

    if (shouldFetchUser) {
        try {
            const res = await getUserInfo(token);
            user = res?.data?.data || {};
            store.commit("SET_USER_INFO", user);
            userInfoLoadedToken = token;
        } catch (error) {
            userInfoLoadedToken = "";
            store.commit("logout");
            return { name: "NotAuthenticated" };
        }
    }

    if (!user.company || !user.name) {
        return { name: "profile", query: { redirect: to.fullPath === "/" ? "/apply" : to.fullPath } };
    }

    if (to.name === "index") {
        return { name: "user_info" };
    }

    return true;
});

router.afterEach(() => {
    document.body?.classList?.remove?.("is-nav-dragging");
});

export default router;
